export * from './common';
export * from './header';
export * from './footer';
//# sourceMappingURL=index.js.map